import { Component } from 'react';
import styled from 'styled-components';

import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';
import InputContainer, { FormInput } from '../Input';

import { COLORS } from '../../../helpers/constants/styleguide';

/**
 * @typedef {Object} PhoneInputOwnProps
 * @property {string} [value]
 * @property {(field: string, value: string) => void} [onChange]
 * @property {(event: React.FocusEvent<HTMLInputElement>) => void} [onBlur]
 * @property {string} [placeholder]
 * @property {boolean} [disabled]
 * @property {boolean} [autoFocus]
 */

/** @typedef {import('../Input').InputFieldProps} InputFieldProps */
/** @typedef {InputFieldProps & PhoneInputOwnProps} PhoneInputProps */

/** @extends {Component<PhoneInputProps>} */
class IdrPhoneInput extends Component {
  static defaultProps = {
    disabled: false,
    onFocus: () => {},
    onBlur: () => {},
    placeholder: '',
  };

  state = {
    initialValue: this.props.value,
  };

  handleChange = event => {
    this.props.onChange(this.props.name, event.target.rawValue);
  };

  renderInputText = (handleFocusChange, focus, { inputId, labelId }) => {
    const { disabled, name, onBlur, placeholder, autoFocus } = this.props;

    return (
      <Input
        id={inputId}
        aria-labelledby={labelId}
        autoFocus={autoFocus}
        inputMode="tel"
        autoComplete="tel-national"
        type="tel"
        name={name}
        value={this.state.initialValue}
        options={{
          blocks: [0, 3, 0, 3, 0, 0, 4],
          delimiters: ['(', ')', ' ', ' ', '-', ' '],
          numericOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
        }}
        placeholder={placeholder}
        onChange={this.handleChange}
        onFocus={handleFocusChange}
        disabled={disabled}
        onBlur={e => {
          handleFocusChange();
          onBlur(e);
        }}
      />
    );
  };

  render() {
    const { error, touched, isSubmitting, label, helpMessage, subTitle } =
      this.props;
    return (
      <InputContainer
        id={this.props.name}
        error={error}
        touched={touched}
        isSubmitting={isSubmitting}
        label={label}
        helpMessage={helpMessage}
        subTitle={subTitle}
      >
        {this.renderInputText}
      </InputContainer>
    );
  }
}

const Input = styled(FormInput.withComponent(Cleave))`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  margin: auto 0;
  caret-color: ${COLORS.darkerGrey};

  &:focus {
    outline: none;
  }
`;

IdrPhoneInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.node,
  subTitle: PropTypes.node,
  helpMessage: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  touched: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.array,
    PropTypes.object,
  ]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default IdrPhoneInput;
